<template>
  <b-container fluid>
    <loading :active.sync="isLoading" color="#00AB63"></loading>
    <b-row>
      <b-col sm="6">
        <div class="my-3 p-3 bg-white rounded shadow-sm">
          <h4 class="border-bottom border-gray pb-2 mb-0">Agregar marca</h4>
          <div class="media text-muted pt-3">
            <b-form @submit.prevent="saveNewBrand($event)" v-if="show" style="width: 100%;">
              <b-row>
                <b-col sm="12">
                  <b-form-group label="Nombre:">
                    <b-form-input
                      v-model="form.Nombre"
                      type="text" 
                      oninvalid="setCustomValidity('Solo se permiten letras, numeros y espacios.')"
                      required
                      placeholder="Nombre de la marca"
                    />
                  </b-form-group>
                  <b-form-group label="Tipo:">
                    <b-form-checkbox-group
                      :options="form.options"
                      v-model="form.optionsSelected"
                      :required="checkbox"
                    />
                  </b-form-group>
                  <b-form-group label="Agregar imagen:">
                    <b-form-file
                      v-model="form.selectedImg"
                      accept="image/jpeg, image/png"
                      placeholder="Ningún archivo elegido"
                      @change="selectImageForNewBrand($event)"
                      browse-text="Buscar"
                    />
                  </b-form-group>
                  <div
                    v-if="form.selectedImg != null && (form.selectedImg.type =='image/png' || form.selectedImg.type =='image/jpeg')"
                  >
                    <b-form-group label="Vista previa">
                      <img id="img_new_brand" class="img-thumbnail" src alt width="200px" />
                    </b-form-group>
                  </div>
                </b-col>
              </b-row>
              <b-button
                :disabled="form.disableBtn"
                type="submit"
                variant="primary"
                class="float-right boton_createch"
              >
                <i class="far fa-save"></i> Guardar
                <b-spinner small v-if="form.disableBtn"></b-spinner>
              </b-button>
            </b-form>
          </div>
        </div>
      </b-col>
      <b-col sm="6">
        <div class="my-3 p-3 bg-white rounded shadow-sm">
          <h4 class="border-bottom border-gray pb-2 mb-0">Marcas</h4>
          <div class="media text-muted pt-3">
            <b-container>
              <!-- Main table element -->
              <b-table
                show-empty
                small
                stacked="sm"
                :items="marcas"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
              >
                <template v-slot:cell(actions)="row">
                  <b-button 
                    size="sm"
                    @click="showDeleteModal(row.item, $event.target)"
                    class="mr-1 float-right btn_borrar"
                  >
                    <i class="far fa-trash-alt"></i>
                  </b-button>
                  <b-button
                    size="sm" 
                    @click="showEditModal(row.item, $event.target)"
                    class="mr-1 float-right btn_editar"
                  >
                    <i class="far fa-edit"></i>
                  </b-button>
                </template>
              </b-table>
              <b-container>
                <b-row>
                  <b-col>
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      align="fill"
                      size="sm"
                      class="my-0"
                    ></b-pagination>
                  </b-col>
                </b-row>
              </b-container>

              <!-- Info modal -->
              <b-modal
                :id="infoModal.id"
                :title="infoModal.title"
                @ok="deleteBrand(infoModal.eliminar)"
                centered
                ok-title="Eliminar"
                cancel-title="Cancelar"
              >
                <p
                  style="text-align:center; font-size:25px; font-weight:bold;"
                >¿Está seguro que desea eliminar?</p>
              </b-modal>
              <!-- Editar modal -->
              <b-modal :id="editModal.id" :title="editModal.title" hide-footer centered>
                <b-container>
                  <b-row>
                    <b-form @submit.prevent="updateBrand($event)" v-if="show" style="width: 100%;">
                      <b-row>
                        <b-col sm="12">
                          <b-form-group label="Nombre:">
                            <b-form-input
                              v-model="editModal.new.Nombre"
                              type="text" 
                              oninvalid="setCustomValidity('Solo se permiten letras, numeros y espacios.')"
                              required
                              placeholder="Nombre"
                            />
                          </b-form-group>
                          <b-form-group label="Tipo:">
                            <b-form-checkbox-group
                              :options="form.options"
                              v-model="editModal.optionsSelected"
                              :required="checkboxEdit"
                            />
                          </b-form-group>
                          <b-form-group v-if="editModal.new.urlImage" label="Imagen:">
                            <b-img thumbnail :src="editModal.new.urlImage" alt width="100px" />
                          </b-form-group>
                          <b-form-group label="Agregar nueva imagen:">
                            <b-form-file
                              accept="image/jpeg, image/png"
                              @change="selectImageForUpdate($event)"
                              v-model="editModal.selectedImg"
                              browse-text="Buscar"
                            ></b-form-file>
                          </b-form-group>
                          <b-form-group label="Nueva imagen:" v-if="editModal.selectedImg != null">
                            <img id="img_edit_brand" src alt style="width:100px;" />
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <hr />
                      <b-row>
                        <b-col>
                          <div class="w-100 float-right">
                            <b-button
                              type="submit"
                              variant="primary"
                              size="sm"
                              :disabled="editModal.disableBtn"
                              class="float-right"
                            >
                              Editar
                              <b-spinner small v-if="editModal.disableBtn"></b-spinner>
                            </b-button>
                            <b-button
                              variant="secondary"
                              size="sm"
                              class="float-right mr-1"
                              @click="hideModal(editModal.id)"
                            >Cancelar</b-button>
                          </div>
                        </b-col>
                      </b-row>
                    </b-form>
                  </b-row>
                </b-container>
                <template v-slot:modal-footer></template>
              </b-modal>
            </b-container>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<style>
</style>
<script>
import axios from "axios";
import * as firebase from "firebase/app";
import "firebase/storage";

// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    Loading
  },
  data() {
    return {
      isLoading: false,
      marcas: [],
      checkbox: true,
      checkboxEdit: true,
      fields: [
        { key: "name", sortable: true, label: "Nombre" },
        { key: "actions", label: "" }
      ],
      show: true,
      show_modal_edit_marca: false,
      form: {
        Nombre: "",
        img: "",
        options: [
          { text: "Industrial", value: "Industrial" },
          {
            text: "Domestico",
            value: "Domestico"
          }
        ],
        selectedImg: null,
        optionsSelected: [],
        disableBtn: false
      },
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
        eliminar: ""
      },
      editModal: {
        id: "edit-modal",
        img: "",
        title: "",
        new: [],
        selectedImg: null,
        disableBtn: false,
        optionsSelected: []
      }
    };
  },
  components: {
    Loading
  },
  created() {
    this.getBrands();
  },
  watch: {
    "form.optionsSelected": function(newValue, old) {
      if (newValue.length > 0) {
        this.checkbox = false;
      } else {
        this.checkbox = true;
      }
    },
    "editModal.optionsSelected": function(newValue, old) {
      if (newValue.length > 0) {
        this.checkboxEdit = false;
      } else {
        this.checkboxEdit = true;
      }
    }
  },
  methods: {
    deleteBrand(marca) {
      this.isLoading = true;
      axios
        .delete("brand/" + marca)
        .then(res => {
          if (res.data.imageName) {
            const imgName = res.data.imageName;
            firebase
              .storage()
              .ref()
              .child(`brands/${imgName}`)
              .delete()
              .then(res => {
                this.getBrands();
                this.resetDeleteModal();
              })
              .then(res => {
                this.isLoading = false;
              })
              .catch(error => {});
          } else {
            this.getBrands();
            this.resetDeleteModal();
          }
        })
        .catch(error => {});
    },
    updateBrand(event) {
      this.editModal.disableBtn = true;
      if (this.editModal.selectedImg == null) {
        axios
          .put(`brand/${this.editModal.new.id}`, {
            name: this.editModal.new.Nombre.trim(),
            type: this.editModal.optionsSelected
          })
          .then(res => {
            if (res.status === 202) {
              this.makeToast(
                "Una marca con ese nombre ya ha sido registrada",
                "Registro de marca"
              );
              this.editModal.disableBtn = false;
            } else {
              this.getBrands();
              this.hideModal(this.editModal.id);
              this.resetEditModal();
            }
          })
          .catch(error => {
            if (error.response.status === 400) {
              this.makeToast("Verifique los datos de la marca.", "Marca");
            } else {
              this.makeToast("Ocurrió un error inesperado.", "Marca");
            }
            this.editModal.disableBtn = false;
          });
      } else {
        const imgName = `${Date.now()}_${this.editModal.selectedImg.name}`;
        const uploadedimg = firebase
          .storage()
          .ref()
          .child(`brands/${imgName}`)
          .put(this.editModal.selectedImg);
        uploadedimg.on(
          `state_changed`,
          snapshot => {},
          error => {},
          () => {
            uploadedimg.snapshot.ref.getDownloadURL().then(url => {
              this.editModal.img = url;
              axios
                .put(`brand/${this.editModal.new.id}`, {
                  name: this.editModal.new.Nombre.trim(),
                  urlImage: this.editModal.img,
                  type: this.editModal.optionsSelected,
                  imageName: imgName
                })
                .then(res => {
                  if (res.status === 202) {
                    this.makeToast(
                      "Una marca con ese nombre ya ha sido registrada",
                      "Registro de marca"
                    );
                    this.editModal.disableBtn = false;
                  } else {
                    this.getBrands();
                    this.hideModal(this.editModal.id);
                    this.resetEditModal();
                  }
                })
                .catch(error => {
                  if (error.response.status === 400) {
                    this.makeToast("Verifique los datos de la marca.", "Marca");
                  } else {
                    this.makeToast("Ocurrió un error inesperado.", "Marca");
                  }
                  this.editModal.disableBtn = false;
                });
            });
          }
        );
      }
    },
    showDeleteModal(item, button) {
      this.resetDeleteModal();
      this.infoModal.title = `Eliminar marca: ${item.name}`;
      this.infoModal.eliminar = item._id;
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    showEditModal(item, button) {
      this.resetEditModal();
      this.editModal.new.Nombre = item.name;
      this.editModal.new.id = item._id;
      this.editModal.new.urlImage = item.urlImage;
      this.editModal.optionsSelected = item.type;
      this.editModal.title = `Editar Marca: ${item.name}`;
      this.$root.$emit("bv::show::modal", this.editModal.id, button);
    },
    hideModal(id) {
      this.$bvModal.hide(id);
    },
    getBrands() {
      this.isLoading = true;
      axios
        .get("brands")
        .then(res => {
          console.log(res.data);

          this.totalRows = res.data.length;
          this.marcas = res.data;
        })
        .then(res => {
          this.isLoading = false;
        })
        .catch(function(error) {
          this.isLoading = false;
        });
    },
    saveNewBrand(event) {
      this.form.disableBtn = true;
      this.isLoading = true;
      if (this.form.selectedImg == null) {
        axios
          .post("brand", {
            name: this.form.Nombre.trim(),
            type: this.form.optionsSelected
          })
          .then(res => {
            if (res.status === 202) {
              this.makeToast(
                "Una marca con ese nombre ya ha sido registrada",
                "Registro de marca"
              );
              this.isLoading = false;
              this.form.disableBtn = false;
            } else {
              this.resetForm();
              this.getBrands();
            }
          })
          .catch(error => {
            if (error.response.status === 400) {
              this.makeToast("Verifique los datos de la marca.", "Marca");
            } else {
              this.makeToast("Ocurrió un error inesperado.", "Marca");
            }
            this.isLoading = false;
            this.form.disableBtn = false;
          });
      } else {
        const imgName = `${Date.now()}_${this.form.selectedImg.name}`;
        const uploadedimg = firebase
          .storage()
          .ref()
          .child(`brands/${imgName}`)
          .put(this.form.selectedImg);
        uploadedimg.on(
          `state_changed`,
          snapshot => {},
          error => {},
          () => {
            uploadedimg.snapshot.ref.getDownloadURL().then(url => {
              this.form.img = url;
              axios
                .post("brand", {
                  name: this.form.Nombre.trim(),
                  urlImage: this.form.img,
                  type: this.form.optionsSelected,
                  imageName: imgName
                })
                .then(res => {
                  if (res.status === 202) {
                    this.makeToast(
                      "Una marca con ese nombre ya ha sido registrada",
                      "Registro de marca"
                    );
                    this.form.disableBtn = false;
                    this.isLoading = false;
                  } else {
                    this.resetForm();
                    this.getBrands();
                  }
                })
                .catch(error => {
                  if (error.response.status === 400) {
                    this.makeToast("Verifique los datos de la marca.", "Marca");
                  } else {
                    this.makeToast("Ocurrió un error inesperado.", "Marca");
                  }
                  this.isLoading = false;
                  this.form.disableBtn = false;
                });
            });
          }
        );
      }
    },
    selectImageForUpdate(event) {
      let img = event.target.files[0];
      if (img) {
        if (
          img.type === "image/png" ||
          img.type === "image/jpg" ||
          img.type === "image/jpeg"
        ) {
          this.editModal.selectedImg = img;
          let reader = new FileReader();
          reader.onload = function(e) {
            document.getElementById("img_edit_brand").src = e.target.result;
          };
          reader.readAsDataURL(img);
        } else {
          this.makeToast(
            "Debe seleccionar una imagen jpg o png",
            "Selección de imagen"
          );
        }
      }
    },
    selectImageForNewBrand(event) {
      let img = event.target.files[0];
      if (img) {
        if (
          img.type === "image/png" ||
          img.type === "image/jpg" ||
          img.type === "image/jpeg"
        ) {
          this.form.selectedImg = img;
          let reader = new FileReader();
          reader.onload = function(e) {
            document.getElementById("img_new_brand").src = e.target.result;
          };
          reader.readAsDataURL(img);
        } else {
          this.form.selectedImg = null;
          this.makeToast(
            "Debe seleccionar una imagen jpg o png.",
            "Selección de imagen"
          );
        }
      }
    },
    resetForm() {
      this.form = {
        Nombre: "",
        img: "",
        options: [
          { text: "Industrial", value: "Industrial" },
          {
            text: "Domestico",
            value: "Domestico"
          }
        ],
        selectedImg: null,
        optionsSelected: [],
        disableBtn: false
      };
      this.isLoading = false;
    },
    resetEditModal() {
      this.editModal = {
        id: "edit-modal",
        img: "",
        title: "",
        new: [],
        selectedImg: null,
        disableBtn: false,
        optionsSelected: []
      };
    },
    resetDeleteModal() {
      this.infoModal = {
        id: "info-modal",
        title: "",
        content: "",
        eliminar: ""
      };
    }
  }
};
</script> 